import PageHero from "@/components/layout/PageHero";

export default function LegalPage({ eyebrow, title, updated, sections, testId }) {
  return (
    <div className="bg-ds-cream" data-testid={testId}>
      <PageHero eyebrow={eyebrow} title={title} subtitle={`Last updated ${updated}.`} />
      <section className="py-14 sm:py-16 bg-ds-cream">
        <div className="container-x grid lg:grid-cols-12 gap-12">
          <nav className="hidden lg:block lg:col-span-3 sticky top-28 self-start border-l-2 border-dotted border-ds-plum/30 pl-4 space-y-2.5">
            {sections.map((s, i) => (
              <a key={s.title} href={`#s${i}`} className="block text-sm text-ds-inksoft hover:text-ds-plum">{s.title}</a>
            ))}
          </nav>
          <article className="lg:col-span-8 legal-prose">
            {sections.map((s, i) => (
              <section key={s.title} id={`s${i}`} className="scroll-mt-28">
                <h2>{i + 1}. {s.title}</h2>
                {s.body.map((p, j) => (Array.isArray(p) ? <ul key={j}>{p.map((li) => <li key={li}>{li}</li>)}</ul> : <p key={j} className="mb-3">{p}</p>))}
              </section>
            ))}
          </article>
        </div>
      </section>
    </div>
  );
}
